import { render, staticRenderFns } from "./GameIframe.vue?vue&type=template&id=7142075a&scoped=true&"
import script from "./GameIframe.vue?vue&type=script&lang=js&"
export * from "./GameIframe.vue?vue&type=script&lang=js&"
import style0 from "./GameIframe.vue?vue&type=style&index=0&id=7142075a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142075a",
  null
  
)

component.options.__file = "GameIframe.vue"
export default component.exports